/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function */
import React from 'react';
import CourseTeaser from 'es6/components/apps/course-teaser';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import { t } from 'es6/services/localization';
import ResultGlyphs from 'es6/components/apps/result-glyphs';

export default React.createClass({
  displayName: 'PlacementScreen',

  propTypes: {
    category: React.PropTypes.object.isRequired,
    correctCount: React.PropTypes.number.isRequired,
    goal: React.PropTypes.object.isRequired,
    incorrectCount: React.PropTypes.number.isRequired,
    onCourseDirectory: React.PropTypes.func.isRequired,
    onStart: React.PropTypes.func.isRequired,
    onSessionDetails: React.PropTypes.func.isRequired,
  },

  render() {
    const strings = {
      courseDirectory: t('diagnostic.course-directory'),
      correct: t('js_iknow.correct'),
      incorrect: t('incorrect'),
      placementResultsMessage: t('placement-results-message'),
      seeSession: t('js_iknow.details'),
      start: t('start', { context: 'js_iknow' }),
      title: t('diag-category-header-label-{category-title}', { 'category-title': this.props.category.name }),
    };

    return (
      <div className="screen screen-placement">
        <div className="screen-content">
          <h1 className="title">{strings.title}</h1>
          <h2 className="placement-message">{strings.placementResultsMessage}</h2>

          <CourseTeaser goal={this.props.goal} />

          <ul className="placement-stats">
            <li className="correct">
              <div className={ResultGlyphs.CORRECT} />
              <div className="primary-item">
                <span className="count">{this.props.correctCount} </span>
                <span className="unit">{strings.correct}</span>
              </div>
            </li>

            <li className="incorrect">
              <div className={ResultGlyphs.INCORRECT} />
              <div className="primary-item">
                <span className="count">{this.props.incorrectCount} </span>
                <span className="unit">{strings.incorrect}</span>
              </div>
            </li>
          </ul>

          <a className="link" onClick={this.props.onSessionDetails}>{strings.seeSession}</a>
        </div>

        <Navigation>
          <NavButton align="left" onClick={this.props.onCourseDirectory}>{strings.courseDirectory}</NavButton>
          <NavButton align="right" focused onClick={this.props.onStart}>{strings.start}</NavButton>
        </Navigation>
      </div>
    );
  },
});
